module.exports = {
  id: 31,
  name: 'Inchworm Walk',
  categories: ['strength', 'core', 'flexibility'],
  sports: [
    'baseball',
    'basketball',
    'boxing',
    'cricket',
    'dance',
    'football',
    'golf',
    'hockey',
    'lacrosse',
    'martial-arts',
    'gymnastics',
    'rugby',
    'soccer',
    'swimming',
    'tennis',
    'track',
    'volleyball',
  ],
  difficulty: 'intermediate',
  skill: 'Core',
  points: 13,
  instructions:
    'Inchworm Walk makes your arms and core super strong! Stand up, bend over and touch the ground, walk your hands out like an inchworm, then walk your feet back to your hands!',
  timedInstructions: [
    {
      time: 0,
      text: "Ready to walk like an inchworm? Let's get crawling!",
    },
    {
      time: 2,
      text: 'Stand with feet apart, get ready!',
    },
    {
      time: 4,
      text: '3, 2, 1, START WALKING!',
    },
    // SET 1 - 5 reps
    {
      time: 7,
      text: 'Bend down and touch the ground with your hands, keep your legs straight!',
    },
    {
      time: 9,
      text: 'Now walk your hands out in front of you like an inchworm, step by step!',
    },
    {
      time: 11,
      text: "Keep walking your hands out until you're in a plank position!",
    },
    {
      time: 13,
      text: 'Now walk your feet back to your hands, one step at a time!',
    },
    {
      time: 15,
      text: 'Stand up tall and straight, great inchworm walk!',
    },
    {
      time: 17,
      text: 'Bend down and touch the ground again, keep your legs straight!',
    },
    {
      time: 19,
      text: 'Walk your hands out in front of you, keep going inchworm!',
    },
    {
      time: 21,
      text: "Keep walking your hands out until you're in a plank position!",
    },
    {
      time: 23,
      text: 'Now walk your feet back to your hands, one step at a time!',
    },
    {
      time: 25,
      text: "Stand up tall and straight, you're doing great!",
    },
    {
      time: 27,
      text: 'Bend down and touch the ground, keep your body controlled!',
    },
    {
      time: 29,
      text: 'Walk your hands out like an inchworm, step by step!',
    },
    {
      time: 31,
      text: "Keep walking your hands out until you're in a plank position!",
    },
    {
      time: 33,
      text: 'Now walk your feet back to your hands, keep it controlled!',
    },
    {
      time: 35,
      text: "Stand up tall and straight, keep going, you're strong!",
    },
    {
      time: 37,
      text: 'Bend down and touch the ground, almost there!',
    },
    {
      time: 39,
      text: 'Walk your hands out in front of you, keep going inchworm!',
    },
    {
      time: 41,
      text: "Keep walking your hands out until you're in a plank position!",
    },
    {
      time: 43,
      text: 'Now walk your feet back to your hands, one step at a time!',
    },
    {
      time: 45,
      text: 'Stand up tall and straight, last one for this set!',
    },
    {
      time: 47,
      text: 'Bend down and touch the ground, final rep of this set!',
    },
    {
      time: 49,
      text: 'Walk your hands out like an inchworm, step by step!',
    },
    {
      time: 51,
      text: "Keep walking your hands out until you're in a plank position!",
    },
    {
      time: 53,
      text: 'Now walk your feet back to your hands, finish strong!',
    },
    // REST PERIOD 1 - 15 seconds
    {
      time: 55,
      text: 'Amazing job! Take a good break now',
    },
    {
      time: 58,
      text: 'Breathe in and out, catch your breath',
    },
    {
      time: 61,
      text: "You just did 5 inchworm walks, that's incredible!",
    },
    {
      time: 64,
      text: 'Your arms and core are getting so strong!',
    },
    {
      time: 67,
      text: 'Remember to keep your body straight',
    },
    {
      time: 70,
      text: 'Walk your hands out slowly and controlled',
    },
    {
      time: 73,
      text: 'Breathe deeply and relax your muscles',
    },
    {
      time: 76,
      text: "You're building amazing inchworm strength!",
    },
    {
      time: 79,
      text: 'Ready for round two, inchworm warrior!',
    },
    {
      time: 82,
      text: '3, 2, 1, KEEP WALKING!',
    },
    // SET 2 - 5 reps
    {
      time: 85,
      text: 'Bend down and touch the ground with your hands, keep your legs straight!',
    },
    {
      time: 87,
      text: 'Now walk your hands out in front of you like an inchworm, step by step!',
    },
    {
      time: 89,
      text: "Keep walking your hands out until you're in a plank position!",
    },
    {
      time: 91,
      text: 'Now walk your feet back to your hands, one step at a time!',
    },
    {
      time: 93,
      text: 'Stand up tall and straight, great inchworm walk!',
    },
    {
      time: 95,
      text: 'Bend down and touch the ground again, keep your legs straight!',
    },
    {
      time: 97,
      text: 'Walk your hands out in front of you, keep going inchworm!',
    },
    {
      time: 99,
      text: "Keep walking your hands out until you're in a plank position!",
    },
    {
      time: 101,
      text: 'Now walk your feet back to your hands, one step at a time!',
    },
    {
      time: 103,
      text: "Stand up tall and straight, you're doing great!",
    },
    {
      time: 105,
      text: 'Bend down and touch the ground, keep your body controlled!',
    },
    {
      time: 107,
      text: 'Walk your hands out like an inchworm, step by step!',
    },
    {
      time: 109,
      text: "Keep walking your hands out until you're in a plank position!",
    },
    {
      time: 111,
      text: 'Now walk your feet back to your hands, keep it controlled!',
    },
    {
      time: 113,
      text: "Stand up tall and straight, keep going, you're strong!",
    },
    {
      time: 115,
      text: 'Bend down and touch the ground, almost there!',
    },
    {
      time: 117,
      text: 'Walk your hands out in front of you, keep going inchworm!',
    },
    {
      time: 119,
      text: "Keep walking your hands out until you're in a plank position!",
    },
    {
      time: 121,
      text: 'Now walk your feet back to your hands, one step at a time!',
    },
    {
      time: 123,
      text: 'Stand up tall and straight, last one for this set!',
    },
    {
      time: 125,
      text: 'Bend down and touch the ground, final rep of this set!',
    },
    {
      time: 127,
      text: 'Walk your hands out like an inchworm, step by step!',
    },
    {
      time: 129,
      text: "Keep walking your hands out until you're in a plank position!",
    },
    {
      time: 131,
      text: 'Now walk your feet back to your hands, finish strong!',
    },
    // REST PERIOD 2 - 15 seconds
    {
      time: 133,
      text: 'Incredible work! Take another break',
    },
    {
      time: 136,
      text: 'Breathe in and out, feel your strength',
    },
    {
      time: 139,
      text: 'You just did 10 inchworm walks total!',
    },
    {
      time: 142,
      text: 'Your arms and core are getting stronger!',
    },
    {
      time: 145,
      text: 'Remember to keep your body straight',
    },
    {
      time: 148,
      text: 'Walk your hands out slowly and controlled',
    },
    {
      time: 151,
      text: 'Breathe deeply and relax your muscles',
    },
    {
      time: 154,
      text: "You're becoming an inchworm master!",
    },
    {
      time: 157,
      text: 'Ready for round three, inchworm champion!',
    },
    {
      time: 160,
      text: '3, 2, 1, KEEP WALKING!',
    },
    // SET 3 - 5 reps
    {
      time: 163,
      text: 'Bend and touch the ground!',
    },
    {
      time: 165,
      text: 'Walk your hands out like an inchworm!',
    },
    {
      time: 167,
      text: 'Walk your feet back to your hands!',
    },
    {
      time: 169,
      text: 'Stand up tall!',
    },
    {
      time: 171,
      text: 'Great inchworm walk!',
    },
    {
      time: 173,
      text: 'Bend and touch the ground again!',
    },
    {
      time: 175,
      text: 'Walk your hands out, keep going!',
    },
    {
      time: 177,
      text: 'Walk your feet back to your hands!',
    },
    {
      time: 179,
      text: 'Stand up tall!',
    },
    {
      time: 181,
      text: "You're doing great!",
    },
    {
      time: 183,
      text: 'Bend and touch the ground!',
    },
    {
      time: 185,
      text: 'Walk your hands out like an inchworm!',
    },
    {
      time: 187,
      text: 'Walk your feet back to your hands!',
    },
    {
      time: 189,
      text: 'Stand up tall!',
    },
    {
      time: 191,
      text: "Keep going, you're strong!",
    },
    {
      time: 193,
      text: 'Bend and touch the ground!',
    },
    {
      time: 195,
      text: 'Walk your hands out, almost there!',
    },
    {
      time: 197,
      text: 'Walk your feet back to your hands!',
    },
    {
      time: 199,
      text: 'Stand up tall!',
    },
    {
      time: 201,
      text: 'Last one for this set!',
    },
    {
      time: 203,
      text: 'Bend and touch the ground!',
    },
    {
      time: 205,
      text: 'Walk your hands out like an inchworm!',
    },
    {
      time: 207,
      text: 'Walk your feet back to your hands!',
    },
    {
      time: 209,
      text: 'Stand up tall!',
    },
    // REST PERIOD 3 - 15 seconds
    {
      time: 211,
      text: 'Fantastic work! Take a final break',
    },
    {
      time: 214,
      text: 'Breathe in and out, feel your power',
    },
    {
      time: 217,
      text: 'You just did 15 inchworm walks total!',
    },
    {
      time: 220,
      text: 'Your arms and core are incredibly strong!',
    },
    {
      time: 223,
      text: 'Remember to keep your body straight',
    },
    {
      time: 226,
      text: 'Walk your hands out slowly and controlled',
    },
    {
      time: 229,
      text: 'Breathe deeply and relax your muscles',
    },
    {
      time: 232,
      text: "You're an inchworm superstar!",
    },
    {
      time: 235,
      text: 'Ready for the final round, inchworm master!',
    },
    {
      time: 238,
      text: '3, 2, 1, FINAL WALK!',
    },
    // SET 4 - 5 reps
    {
      time: 241,
      text: 'Bend and touch the ground!',
    },
    {
      time: 243,
      text: 'Walk your hands out like an inchworm!',
    },
    {
      time: 245,
      text: 'Walk your feet back to your hands!',
    },
    {
      time: 247,
      text: 'Stand up tall!',
    },
    {
      time: 249,
      text: 'Great inchworm walk!',
    },
    {
      time: 251,
      text: 'Bend and touch the ground again!',
    },
    {
      time: 253,
      text: 'Walk your hands out, keep going!',
    },
    {
      time: 255,
      text: 'Walk your feet back to your hands!',
    },
    {
      time: 257,
      text: 'Stand up tall!',
    },
    {
      time: 259,
      text: "You're doing great!",
    },
    {
      time: 261,
      text: 'Bend and touch the ground!',
    },
    {
      time: 263,
      text: 'Walk your hands out like an inchworm!',
    },
    {
      time: 265,
      text: 'Walk your feet back to your hands!',
    },
    {
      time: 267,
      text: 'Stand up tall!',
    },
    {
      time: 269,
      text: "Keep going, you're strong!",
    },
    {
      time: 271,
      text: 'Bend and touch the ground!',
    },
    {
      time: 273,
      text: 'Walk your hands out, almost there!',
    },
    {
      time: 275,
      text: 'Walk your feet back to your hands!',
    },
    {
      time: 277,
      text: 'Stand up tall!',
    },
    {
      time: 279,
      text: 'Last one for this set!',
    },
    {
      time: 281,
      text: 'Bend and touch the ground!',
    },
    {
      time: 283,
      text: 'Walk your hands out like an inchworm!',
    },
    {
      time: 285,
      text: 'Walk your feet back to your hands!',
    },
    {
      time: 287,
      text: 'Stand up tall!',
    },
    {
      time: 289,
      text: 'You did it, inchworm master!',
    },
    {
      time: 291,
      text: 'Incredible work! You did 20 inchworm walks!',
    },
    {
      time: 293,
      text: 'Your arms and core are incredibly strong!',
    },
    {
      time: 295,
      text: 'You are an inchworm champion!',
    },
  ],
};
